export class ExecuteNotebookCodeInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "code",
            "baseName": "code",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ExecuteNotebookCodeInput.attributeTypeMap;
    }
    constructor() {
    }
}
